/**
 * Логгер клиента: молчит в production. `console.log` в коде запрещён
 * (docs/08 §2.8), поэтому единственная точка вывода — здесь.
 */

type LogArgs = readonly unknown[];

const isEnabled = import.meta.env.DEV;

export const logger = {
  debug(...args: LogArgs): void {
    if (isEnabled) {
      // eslint-disable-next-line no-console
      console.debug('[tasks]', ...args);
    }
  },
  warn(...args: LogArgs): void {
    if (isEnabled) {
      // eslint-disable-next-line no-console
      console.warn('[tasks]', ...args);
    }
  },
};
